/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as a from "react";
const e = a.createContext(
  void 0
);
e.displayName = "KendoReactTableKeyboardNavigationContext";
export {
  e as TableKeyboardNavigationContext
};
